import React from 'react';
import PropTypes from 'prop-types';

import { CheckboxStyle } from './CheckboxStyle';

const Checkbox = ({ checked, children, error, inputName, onChange, theme }) => {
  return (
    <CheckboxStyle>
      <label
        className={`checkbox-wrapper ${theme}-theme${
          checked ? ' checked' : ''
        }${error && error.length ? ' with-error' : ''}`}
        htmlFor={inputName}
      >
        <div className="checkbox-content">{children}</div>
        <input
          type="checkbox"
          id={inputName}
          name={inputName}
          checked={checked}
          onChange={onChange}
        />
        <span className="checkbox-checkmark" />
      </label>
      {error.length ? <p className="checkbox-error">{error}</p> : null}
    </CheckboxStyle>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  theme: PropTypes.string,
  inputName: PropTypes.string.isRequired,
  error: PropTypes.string,
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
};

Checkbox.defaultProps = {
  checked: false,
  theme: 'default',
  error: '',
};

export default Checkbox;
